'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '@/frontend/utils';
export interface LabelProps {
  className?: string;
}
export function Label(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("select-none text-contentPrimary text-sm leading-5 data-disabled:opacity-50 sm:text-sm/6", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <Headless.Label data-slot="label" {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}